import React, { useState } from "react";
import { Button, ButtonGroup, Modal } from "react-bootstrap";
import { SubscriptionStrings } from "../../../../business/core";
import { SubscriptionStatementPageControllerImpl } from "../../../../business/impl";

interface IStrategyStatementButtonCancelWaiting {
    id: string;
    biStatus: string | null;
}

export const StrategyStatementButtonCancelWaiting: React.FC<IStrategyStatementButtonCancelWaiting> = ({ id, biStatus }) => {
    const [showModal, setShowModal] = useState<boolean>(false);
    const [isLoading, setLoading] = useState<boolean>(false);
    const strings = SubscriptionStrings['PTBR'].statement.status.WAITING;
    const handlerCancelPlan = async () => {
        setLoading(true);
        const controller = new SubscriptionStatementPageControllerImpl();
        await controller.updateSubscription('CANCELLED', id);
        window.location.reload();
    }

    return (
        <>
            <div className="d-flex justify-content-between">
                <ButtonGroup aria-label="Basic example">
                    {biStatus !== null
                        ? <a
                            className="btn btn-outline-secondary"
                            href={`${process.env.REACT_APP_API}/uploads/bank_invoices/bank-slip.php?${id}`}
                            target="_blank" rel="noreferrer">{strings.download_button_label}</a>
                        : null
                    }
                    <Button variant="outline-danger" onClick={() => setShowModal(true)}>{strings.cancel_button_label}</Button>
                </ButtonGroup>
            </div>
            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{strings.modal_title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{strings.modal_description}</Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>{strings.modal_button_cancel_label}</Button>
                    <Button variant="primary" onClick={() => handlerCancelPlan()} disabled={isLoading}>{strings.modal_button_confirm_label}</Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}